function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 11c0-6.0758-4.9242-11-11-11S0 4.9242 0 11s4.9242 11 11 11c.0645 0 .129 0 .1934-.0043v-8.5594H8.83V10.682h2.3633V8.654c0-2.3505 1.4351-3.631 3.532-3.631 1.0055 0 1.8691.073 2.1183.1075v2.4578H15.4c-1.1387 0-1.3621.5414-1.3621 1.3363v1.7531h2.7285l-.3566 2.7543h-2.372v8.1426C18.6356 20.2555 22 16.023 22 11z",
  fill: "#036FE2",
  fillRule: "nonzero"
});

var SvgFbIcon = function SvgFbIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFbIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fbIcon.9c20b492.svg";
export { ForwardRef as ReactComponent };